    <PreventiveMaintenanceCommonSearch    detailsType="Home"  AddUrl="Home/PreventiveMaintenance"></PreventiveMaintenanceCommonSearch>